
export function showSystemError(err, msg = 'error.systemError') {
  const detail = err && err.response ? ('\n Detail[CODE=' + err.response.status + '] = ' + err.response.url) : '';

  console.log(err);
  console.log(detail);

  return detail;
}
